import { graphql } from "gql.tada";

export const Get404s = graphql(/* GraphQL */ `
  query Get404s($locale: String, $preview: Boolean) {
    contentType404PageCollection(locale: $locale, preview: $preview) {
      items {
        displayTitle
        title {
          json
        }
        body {
          json
        }
        background {
          url
          contentType
        }
        buttonText
      }
    }
  }
`);
